export const FETCH_REFERRER_CONDITIONS = 'FETCH_REFERRER_CONDITIONS';
export const FETCH_REFERRER_CONDITIONS_LOADING = 'FETCH_REFERRER_CONDITIONS_LOADING';
export const FETCH_REFERRER_CONDITIONS_ERROR = 'FETCH_REFERRER_CONDITIONS_ERROR';

export const FETCH_REFERRER_CONDITION_BY_ID = 'FETCH_REFERRER_CONDITION_BY_ID';
export const FETCH_REFERRER_CONDITION_BY_ID_LOADING = 'FETCH_REFERRER_CONDITION_BY_ID_LOADING';
export const FETCH_REFERRER_CONDITION_BY_ID_ERROR = 'FETCH_REFERRER_CONDITION_BY_ID_ERROR';

export const SET_CONDITION_FILTERS = 'SET_CONDITION_FILTERS';
export const RESET_CONDITION_FILTERS = 'RESET_CONDITION_FILTERS';
export const SET_CONDITION_SORT_PARAMS = 'SET_CONDITION_SORT_PARAMS';
export const SET_CONDITION_PAGINATION = 'SET_CONDITION_PAGINATION';
export const RESET_CONDITION_PAGINATION = 'RESET_CONDITION_PAGINATION';

